import useEmblaCarousel from 'embla-carousel-react'
// import Autoplay from 'embla-carousel-autoplay'
import './Carousel.css'
import { useCallback, useEffect, useRef } from 'react'
import DarthByte from '../../assets/images/profile_darth_byte.png'
import Gandalf from '../../assets/images/profile_gandalf_the_code.png'
// import Lara from '../../assets/images/profile_lara_crofix.png'
import Yees from '../../assets/images/profile_yees_cosmic.png'
import NeoScript from '../../assets/images/profile_neoscript.png'
import Rick from '../../assets/images/profile_rick_devchez.png'

const OPTIONS = { loop: true }
// const SLIDE_COUNT = 5
const SLIDES = [
    DarthByte,
    Gandalf,
    Yees,
    Rick,
    NeoScript,
]
const TWEEN_FACTOR_BASE = 0.10
const TWEEN_FACTOR_BASE_OPACITY = 0.70
const numberWithinRange = (number, min, max) =>
  Math.min(Math.max(number, min), max)

const Carousel = () => {
    // const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS, [Autoplay()])
    const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS)
    const tweenFactor = useRef(0)
    const tweenFactorOpacity = useRef(0)
    const tweenNodes = useRef([])

    const setTweenNodes = useCallback((emblaApi) => {
        tweenNodes.current = emblaApi.slideNodes().map((slideNode) => {
            return slideNode.querySelector('.embla__slide__img')
        })
    }, [])

    const setTweenFactor = useCallback((emblaApi) => {
        tweenFactor.current = TWEEN_FACTOR_BASE * emblaApi.scrollSnapList().length
        tweenFactorOpacity.current = TWEEN_FACTOR_BASE_OPACITY * emblaApi.scrollSnapList().length
    }, [])

    const tweenScale = useCallback((emblaApi, eventName) => {
        const engine = emblaApi.internalEngine()
        const scrollProgress = emblaApi.scrollProgress()
        const slidesInView = emblaApi.slidesInView()
        const isScrollEvent = eventName === 'scroll'

        emblaApi.scrollSnapList().forEach((scrollSnap, snapIndex) => {
            let diffToTarget = scrollSnap - scrollProgress
            const slidesInSnap = engine.slideRegistry[snapIndex]

            slidesInSnap.forEach((slideIndex) => {
                if (isScrollEvent && !slidesInView.includes(slideIndex)) return

                if (engine.options.loop) {
                engine.slideLooper.loopPoints.forEach((loopItem) => {
                    const target = loopItem.target()

                    if (slideIndex === loopItem.index && target !== 0) {
                    const sign = Math.sign(target)

                    if (sign === -1) {
                        diffToTarget = scrollSnap - (1 + scrollProgress)
                    }
                    if (sign === 1) {
                        diffToTarget = scrollSnap + (1 - scrollProgress)
                    }
                    }
                })
                }

                const tweenValue = 1 - Math.abs(diffToTarget * tweenFactor.current)
                const tweenValueOpacity = 1 - Math.abs(diffToTarget * tweenFactorOpacity.current)
                const scale = numberWithinRange(tweenValue, 0, 1).toString()
                const tweenNode = tweenNodes.current[slideIndex]
                tweenNode.style.transform = `scale(${scale})`;
                const opacity = numberWithinRange(tweenValueOpacity, 0, 1).toString()
                tweenNode.style.opacity = opacity;
            })
        })
    }, [])

    useEffect(() => {
        if (!emblaApi) return

        setTweenNodes(emblaApi)
        setTweenFactor(emblaApi)
        tweenScale(emblaApi)

        emblaApi
        .on('reInit', setTweenNodes)
        .on('reInit', setTweenFactor)
        .on('reInit', tweenScale)
        .on('scroll', tweenScale)
        .on('slideFocus', tweenScale)
        // eslint-disable-next-line
    }, [emblaApi, tweenScale])
        
    return (
        <div className="embla">
            <div className="embla__viewport" ref={emblaRef}>
                <div className="embla__container">
                    {SLIDES.map((item, index) => (
                        <div className="embla__slide" key={index}>
                            <div
                                className="embla__slide__img"
                                style={{ backgroundImage: `url(${item})` }}
                            >
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Carousel